import { render, staticRenderFns } from "./BattleRegisterParticipantsModal.vue?vue&type=template&id=a531390c&scoped=true"
import script from "./BattleRegisterParticipantsModal.vue?vue&type=script&lang=js"
export * from "./BattleRegisterParticipantsModal.vue?vue&type=script&lang=js"
import style0 from "./BattleRegisterParticipantsModal.vue?vue&type=style&index=0&id=a531390c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a531390c",
  null
  
)

export default component.exports